import React from 'react'

const PaymentSuccess = () => {
  return (
    <div className="row mt-5">
      <div className="col-12 text-center">
        <h1>Tack för din betalning!</h1>
      </div>
    </div>
  )
}

export default PaymentSuccess
